import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RecordingSegmentTransferFailedAction = {
	type: 'RECORDING_SEGMENT_TRANSFER_FAILED';
	payload: ExtractedMessages;
	/** Read straight off the HTTP response — see `interviewCreationFailed.ts` for why. */
	status: number | null;
};

export default (payload: ExtractedMessages, status: number | null): RecordingSegmentTransferFailedAction => ({
	type: 'RECORDING_SEGMENT_TRANSFER_FAILED',
	payload,
	status,
});
